// Font awesome
require("./libs/font-awesome-5.6.3/scss/fontawesome.scss");
require("./libs/font-awesome-5.6.3/scss/brands.scss");
require("./libs/font-awesome-5.6.3/scss/solid.scss");

// TS App
require("./scss/app.scss");


// We should add all sub includes here. Integration themes...